// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sktooltip {\n  position: absolute;\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity));\n  --bg-opacity: 1;\n  z-index: 99999;\n}[dir] .sktooltip {\n  padding: 0.25rem;\n  border-radius: 4px;\n  background-color: #22292f;\n  background-color: rgba(34, 41, 47, var(--bg-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
